module.exports = __webpack_public_path__ + "static/media/clint-mckoy.f5d7f8b5.jpg";